export enum EEntity {
    speed = 'speed',
    onlineCinemas = 'onlineCinemas',
    tv = 'tv',
    antivirus = 'antivirus',
    additional = 'additional',
    routers = 'routers',
    decoders = 'decoders',
    security = 'security',
    entertainments = 'entertainments',
    services = 'services', // Only for selectedEntitiesIds
}
